import { render, staticRenderFns } from "./ItemizerFontPicker.vue?vue&type=template&id=8d771de6&scoped=true&"
import script from "./ItemizerFontPicker.vue?vue&type=script&lang=js&"
export * from "./ItemizerFontPicker.vue?vue&type=script&lang=js&"
import style0 from "./ItemizerFontPicker.vue?vue&type=style&index=0&id=8d771de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d771de6",
  null
  
)

export default component.exports